<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.4873 4.50765C15.8085 -0.171497 8.18789 -0.171497 3.5091 4.50765C-1.1697 9.1868 -1.1697 16.808 3.5091 21.4871C8.19273 26.1711 15.8085 26.1663 20.4873 21.4871C25.1709 16.8031 25.1709 9.1868 20.4873 4.50765ZM11.6716 23.4323C9.34913 23.3597 7.04602 22.5178 5.18321 20.9113L12.0006 14.0885L14.7489 16.837C13.1086 18.6903 12.0393 20.9839 11.6716 23.4323ZM18.818 20.9065L15.8665 17.9548C14.5311 19.4935 13.6408 21.3565 13.2828 23.3549C15.2762 23.113 17.2068 22.2952 18.818 20.9065ZM16.96 16.8612C18.4987 15.5257 20.3615 14.6353 22.3598 14.2821C22.113 16.2757 21.3001 18.2064 19.9115 19.8177L16.96 16.8612ZM15.8423 15.7386C17.6955 14.1031 19.9889 13.0337 22.4372 12.6659C22.3646 10.3433 21.5227 8.04 19.9115 6.17705L13.0941 12.995L15.8423 15.7386ZM7.19601 9.28358C5.61867 10.6578 3.68328 11.5675 1.61242 11.9014C1.82531 9.84005 2.65753 7.83677 4.08971 6.17705L7.19601 9.28358ZM10.9071 2.60115C8.84593 2.8189 6.8428 3.64634 5.18321 5.07864L8.2895 8.18517C9.66363 6.60771 10.5733 4.67217 10.9071 2.60115ZM12.4699 2.56728C14.744 2.6689 16.9891 3.50602 18.818 5.08347L12.0006 11.9014L9.38299 9.28358C11.0523 7.40127 12.1264 5.06412 12.4699 2.56728ZM8.2895 10.3772C6.40734 12.0417 4.07036 13.1159 1.57371 13.4643C1.67532 15.7434 2.51237 17.9838 4.08487 19.8129L10.9071 12.995L8.2895 10.3772Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "BasketBallIcon",
});
</script>
